
import React from "react";

export default function AboutPage() {
  const features = [
    { icon: "💊", title: "Medicines" },
    { icon: "🩺", title: "Surgical Items" },
    { icon: "💇", title: "Hair & Skin Care" },
    { icon: "❤️", title: "Intimate Care" },
    { icon: "💪", title: "Multivitamins" },
    { icon: "🚚", title: "Fast Delivery" },
  ];

  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <h1 style={styles.heading}>About PharmaHelp</h1>
        <p style={styles.heroText}>
          Your trusted online pharmacy platform for medicines, healthcare
          products, and wellness essentials.
        </p>
      </div>

      {/* About Content */}
      <div style={styles.container}>
        <p>
          PharmaHelp is a trusted online pharmacy platform dedicated to making
          healthcare simple, affordable, and accessible. We provide genuine
          medicines, healthcare products, surgical items, multivitamins, health
          supplements, hair & skin care products, and intimate wellness
          products through a convenient online experience.
        </p>

        <p>
          Our platform enables users to upload prescriptions, connect with
          licensed pharmacy professionals, and order healthcare products from
          the comfort of their homes. We focus on providing quality products,
          transparent pricing, and a smooth ordering experience.
        </p>

        <p>
          At PharmaHelp, customers can explore a wide range of healthcare
          categories including generic medicines, branded medicines, surgical
          items, multivitamins, health supplements, hair care products, skin
          care essentials, and intimate wellness products.
        </p>

        <p>
          We are committed to delivering genuine products with reliable service,
          helping customers save time while ensuring easy access to their
          healthcare needs.
        </p>

        {/* Feature Cards */}
       <h2 style={styles.sectionTitle}>What We Offer</h2>

{/* Medicines */}
<div style={styles.offerSection}>
  <div style={styles.textContent}>
    <h3>🔹 Generic & Branded Medicines</h3>
    <p>
      Access a wide range of genuine generic and branded medicines at
      competitive prices. Upload prescriptions, browse products, and order
      healthcare essentials conveniently from your home.
    </p>
  </div>


</div>

{/* Surgical */}
<div style={styles.offerSectionReverse}>


  <div style={styles.textContent}>
    <h3>🔹 Surgical Items</h3>
    <p>
      Explore surgical and healthcare essentials including first aid products,
      wound care items, medical accessories, and other healthcare supplies.
    </p>
  </div>
</div>

{/* Hair & Skin */}
<div style={styles.offerSection}>
  <div style={styles.textContent}>
    <h3>🔹 Hair & Skin Care</h3>
    <p>
      Discover quality hair care and skincare products designed to support
      healthy skin, stronger hair, and everyday personal care needs.
    </p>
  </div>


</div>

{/* Intimate Care */}
<div style={styles.offerSectionReverse}>


  <div style={styles.textContent}>
    <h3>🔹 Intimate Care</h3>
    <p>
      Shop intimate wellness products with privacy, convenience, and trusted
      quality. Your comfort, confidence, and well-being remain our priority.
    </p>
  </div>
</div>

{/* Supplements */}
<div style={styles.offerSection}>
  <div style={styles.textContent}>
    <h3>🔹 Multivitamins & Health Supplements</h3>
    <p>
      Support your daily nutrition and wellness goals with multivitamins,
      health supplements, immunity support products, and wellness essentials.
    </p>
  </div>

</div>

{/* Delivery */}
<div style={styles.offerSectionReverse}>


  <div style={styles.textContent}>
    <h3>🔹 Fast Delivery</h3>
    <p>
      Experience fast and reliable delivery services designed to bring
      medicines and healthcare products directly to your doorstep.
    </p>
  </div>
</div>

        {/* Why Choose Us */}
        <h2 style={styles.sectionTitle}>Why Choose PharmaHelp?</h2>

        <ul style={styles.list}>
          <li>✔ Genuine and trusted healthcare products</li>
          <li>✔ Generic and branded medicines</li>
          <li>✔ Surgical and healthcare essentials</li>
          <li>✔ Hair & Skin Care products</li>
          <li>✔ Intimate Wellness products</li>
          <li>✔ Multivitamins and Health Supplements</li>
          <li>✔ Prescription upload facility</li>
          <li>✔ Easy ordering process</li>
          <li>✔ Fast and reliable delivery service</li>
        </ul>

        {/* Mission */}
        <h2 style={styles.sectionTitle}>Our Mission</h2>

        <p>
          Our mission is to simplify healthcare access through technology and
          provide customers with a dependable platform for their everyday
          healthcare requirements.
        </p>

        <div style={styles.footerBox}>
          <strong>PharmaHelp – Your Health, Our Priority.</strong>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    background: "#f4f7fb",
    minHeight: "100vh",
    paddingBottom: "40px",
  },

  hero: {
    background: "linear-gradient(135deg, #0f172a, #2563eb)",
    color: "#fff",
    textAlign: "center",
    padding: "60px 20px",
  },

  heading: {
    margin: 0,
    fontSize: "42px",
    fontWeight: "700",
  },

  heroText: {
    marginTop: "15px",
    fontSize: "18px",
    maxWidth: "700px",
    marginLeft: "auto",
    marginRight: "auto",
  },

  container: {
    maxWidth: "1000px",
    margin: "30px auto",
    padding: "35px",
    background: "#fff",
    borderRadius: "14px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
    lineHeight: 1.9,
    fontSize: "16px",
  },

  sectionTitle: {
    marginTop: "35px",
    marginBottom: "20px",
    color: "#2563eb",
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "15px",
  },

  card: {
    background: "#f8fafc",
    borderRadius: "12px",
    padding: "20px",
    textAlign: "center",
    border: "1px solid #e5e7eb",
  },

  icon: {
    fontSize: "40px",
    marginBottom: "10px",
  },

  list: {
    paddingLeft: "20px",
    lineHeight: "2",
  },

  footerBox: {
    marginTop: "30px",
    padding: "20px",
    textAlign: "center",
    background: "#eff6ff",
    borderRadius: "12px",
    color: "#1e40af",
    fontSize: "18px",
  },
};

